function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _excluded = ["apiStatus", "apiStatusAttributesConfig", "apiStatusHtmlAttributesConfig", "children", "disableApiStatus", "iconAttributes", "isThemeDark", "style", "type"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
//
import * as React from 'react';
import PropTypes from 'prop-types';
import { color } from "../../styles/theme";
import SvgButton from "./SvgButton";
import { SvgLoaderSignal, SvgCheckSolid, SvgCircleWarning } from "../../svg";
import withApiStatusUIInfo from "../hoc/withApiStatusUIInfo";
import { BUTTON_TYPES } from "./Button";
import { API_BEFORE_SEND, apiStatusPropType, errorPropType } from "../../constants/sharedConstants";
var SvgButtonWithApiStatus = withApiStatusUIInfo(SvgButton);

/**
 * A Button that handles ApiStatus changes.
 */
export default function ApiButton(_ref) {
  var apiStatusAlt = _ref.apiStatus,
    _ref$apiStatusAttribu = _ref.apiStatusAttributesConfig,
    apiStatusAttributesConfig = _ref$apiStatusAttribu === void 0 ? {} : _ref$apiStatusAttribu,
    _ref$apiStatusHtmlAtt = _ref.apiStatusHtmlAttributesConfig,
    apiStatusHtmlAttributesConfig = _ref$apiStatusHtmlAtt === void 0 ? {} : _ref$apiStatusHtmlAtt,
    children = _ref.children,
    disableApiStatus = _ref.disableApiStatus,
    _ref$iconAttributes = _ref.iconAttributes,
    iconAttributes = _ref$iconAttributes === void 0 ? {
      size: 18
    } : _ref$iconAttributes,
    isThemeDark = _ref.isThemeDark,
    _ref$style = _ref.style,
    style = _ref$style === void 0 ? {} : _ref$style,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'secondary' : _ref$type,
    rest = _objectWithoutProperties(_ref, _excluded);
  var apiStatus = disableApiStatus ? API_BEFORE_SEND : apiStatusAlt;
  var baseIconProps = _objectSpread(_objectSpread({}, iconAttributes), {}, {
    isThemeDark: isThemeDark
  });
  var baseApiBtnStyle = _objectSpread(_objectSpread({}, style), {}, {
    backgroundColor: 'transparent'
  });
  if (type === 'icon') {
    baseApiBtnStyle.borderColor = 'transparent';
  }
  return /*#__PURE__*/React.createElement(SvgButtonWithApiStatus, _extends({
    apiStatus: apiStatus,
    isThemeDark: isThemeDark,
    type: type,
    apiStatusAttributesConfig: _objectSpread({
      style: {
        API_BEFORE_SEND: style,
        API_IN_PROGRESS: _objectSpread({
          color: isThemeDark ? color.disabledThemeDark : color.disabled,
          borderColor: isThemeDark ? color.disabledThemeDark : color.disabled
        }, baseApiBtnStyle),
        API_SUCCESS: _objectSpread({
          color: color.success,
          borderColor: color.success
        }, baseApiBtnStyle),
        API_ERROR: _objectSpread({
          color: color.danger,
          borderColor: color.danger
        }, baseApiBtnStyle)
      },
      svgElement: {
        API_BEFORE_SEND: children,
        API_IN_PROGRESS: /*#__PURE__*/React.createElement(SvgLoaderSignal, _extends({
          color: isThemeDark ? color.white : color.white
        }, baseIconProps)),
        API_SUCCESS: /*#__PURE__*/React.createElement(SvgCheckSolid, _extends({
          color: color.success
        }, baseIconProps)),
        API_ERROR: /*#__PURE__*/React.createElement(SvgCircleWarning, _extends({
          color: color.danger
        }, baseIconProps))
      }
    }, apiStatusAttributesConfig),
    apiStatusHtmlAttributesConfig: _objectSpread({
      disabled: {
        API_BEFORE_SEND: false,
        API_IN_PROGRESS: true,
        API_SUCCESS: true,
        API_ERROR: true
      }
    }, apiStatusHtmlAttributesConfig)
  }, rest));
}
ApiButton.propTypes = {
  children: PropTypes.node,
  apiStatus: apiStatusPropType,
  disableApiStatus: PropTypes.bool,
  isThemeDark: PropTypes.bool,
  type: PropTypes.oneOf(Object.keys(BUTTON_TYPES)),
  /* eslint-disable react/forbid-prop-types */
  apiStatusAttributesConfig: PropTypes.object,
  apiStatusHtmlAttributesConfig: PropTypes.object,
  iconAttributes: PropTypes.object,
  style: PropTypes.object
  /* eslint-disable react/forbid-prop-types */
};
export { apiStatusPropType };
export { errorPropType };